var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.843,
    height: 18.509,
    viewBox: "0 0 25.843 18.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-check",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M25.085,59.533,11.452,72.951a2.616,2.616,0,0,1-3.658,0L.757,66.024a2.518,2.518,0,0,1,0-3.6,2.615,2.615,0,0,1,3.657,0l5.21,5.128,11.8-11.618a2.616,2.616,0,0,1,3.658,0A2.518,2.518,0,0,1,25.085,59.533Z",
    transform: "translate(0 -55.188)",
    fill: "#0ecc00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.6fdce6eb6849fd90e64ace0fd9a60c29.svg";
export { ForwardRef as ReactComponent };